export const getCalendarWorks = async ({ urlParams }) => {
  let calendarEndpoint = '/works/calendar.json?';
  calendarEndpoint += urlParams.toString();

  const response = await fetch(calendarEndpoint);

  const contentType = response.headers.get('content-type');

  if (!contentType || !contentType.includes('application/json')) {
    throw new TypeError("Oops, we haven't got JSON!");
  }

  const responseJson = await response.json();

  if (!response.ok) {
    throw new Error(`Error ${response.status}: ${responseJson.error}`);
  }

  return responseJson;
}

export const updateWork = async ({ id, body }) => {
  const response = await fetch(`/works/${id}`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });

  const responseJson = await response.json();

  if (!response.ok) {
    throw new Error(`Error ${response.status}: ${responseJson.error}`);
  }

  return responseJson;
}

export const getWorksSearch = async ({ accountId = window.currentAccountId, q, includeTeamWorks = true, statuses = ['reviewed'], withoutInvoice = true, rootIds = [] }) => {
  const query = new URLSearchParams();

  query.append('include_team_works', includeTeamWorks);
  if (accountId) query.append('account_id', accountId);
  if (statuses && statuses.length) {
    statuses.forEach(status => query.append('statuses[]', status));
  }
  if (withoutInvoice) query.append('without_invoice', withoutInvoice);
  if (rootIds && rootIds.length) {
    rootIds.forEach(id => query.append('root_ids[]', id));
  }

  if (q) query.append('q', q);

  const response = await fetch(`/works.json?${query.toString()}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    throw new TypeError('Resposta não é JSON!');
  }

  const responseJson = await response.json();

  if (!response.ok) {
    throw new Error(`Error ${response.status}: ${responseJson.error}`);
  }

  return responseJson;
};

